import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.modalId = `modal-${Math.random().toString(36).substr(2, 9)}`
  }

  disconnect() {
    this.close()
  }

  open(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (!this.hasContentTarget) {
      console.warn("Modal controller: content target not found")
      return
    }

    // Create modal element if it doesn't exist
    let modalElement = document.getElementById(this.modalId)
    if (modalElement) return

    const content = this.contentTarget.content.cloneNode(true)
    
    // Create modal element with absolute positioning for close button
    const modalHtml = `
      <div id="${this.modalId}" class="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm transition-all duration-300">
        <div class="bg-white w-full max-w-lg rounded-[2.5rem] shadow-2xl overflow-hidden border border-gray-100 max-h-[90vh] flex flex-col transform transition-all duration-300 scale-100 opacity-100">
          <div class="relative flex-grow overflow-y-auto no-scrollbar scroll-smooth">
            <button type="button" class="absolute top-6 right-6 p-3 bg-gray-50 rounded-2xl text-gray-400 hover:text-gray-600 transition z-[10001] modal-close-btn cursor-pointer shadow-sm">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </button>
            <div class="modal-body-content"></div>
          </div>
        </div>
      </div>
    `
    
    document.body.insertAdjacentHTML('beforeend', modalHtml)
    modalElement = document.getElementById(this.modalId)
    modalElement.querySelector('.modal-body-content').appendChild(content)
    const autoplayVideo = modalElement.querySelector("video[autoplay]")
    if (autoplayVideo) {
      autoplayVideo.play().catch(() => {
        // Browser autoplay rules may require the user to press the visible play control.
      })
    }
    
    // Add event listeners
    modalElement.querySelector('.modal-close-btn').addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.close()
    })

    modalElement.querySelectorAll('[data-modal-dismiss]').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        this.close()
      })
    })

    modalElement.addEventListener('click', (e) => {
      const modalContainer = modalElement.querySelector('.bg-white')
      if (modalContainer && !modalContainer.contains(e.target)) {
        this.close()
      }
    })

    // Handle escape key
    this.handleKeyDown = (e) => {
      if (e.key === "Escape") this.close()
    }
    document.addEventListener('keydown', this.handleKeyDown)

    this.toggleScrollLock(true)
  }

  close() {
    const modalElement = document.getElementById(this.modalId)
    if (modalElement) {
      modalElement.remove()
      this.toggleScrollLock(false)
      if (this.handleKeyDown) {
        document.removeEventListener('keydown', this.handleKeyDown)
      }
    }
  }

  toggleScrollLock(lock, force = false) {
    const body = document.body
    const html = document.documentElement
    let openModals = parseInt(body.dataset.openModals || "0")

    if (lock) {
      openModals++
      body.dataset.openModals = openModals
      
      if (openModals === 1) {
        this.scrollPos = window.pageYOffset
        body.style.position = 'fixed'
        body.style.top = `-${this.scrollPos}px`
        body.style.width = '100%'
        body.classList.add('overflow-hidden')
        html.classList.add('overflow-hidden')
      }
    } else {
      openModals = force ? 0 : Math.max(0, openModals - 1)
      body.dataset.openModals = openModals
      
      if (openModals === 0) {
        const scrollY = body.style.top
        body.style.position = ''
        body.style.top = ''
        body.style.width = ''
        body.classList.remove('overflow-hidden')
        html.classList.remove('overflow-hidden')
        if (!force) {
          window.scrollTo(0, parseInt(scrollY || '0') * -1)
        }
      }
    }
  }
}
